import * as Sentry from "@sentry/react";

// Vite inlines `import.meta.env.*` at build time. The DSN can therefore be
// safely committed in build output (it's a public DSN by design).
// We additionally gate on MODE so `vite dev` never reports — the prod project
// would fill up with dev noise otherwise.
export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn || import.meta.env.MODE !== "production") return;
  Sentry.init({
    dsn,
    release: import.meta.env.VITE_GIT_SHA || undefined,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
    // Attach the React component stack so we get a useful breadcrumb trail.
    integrations: [],
  });
}

export function setSentryUser(user: { id?: number; email?: string } | null): void {
  if (!import.meta.env.VITE_SENTRY_DSN) return;
  if (!user || !user.id) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({ id: String(user.id), email: user.email });
}
